export default "__VITE_ASSET__BJT7mxUw__"